define.alias("ember-basic-dropdown/components/basic-dropdown-wormhole", "settings/components/basic-dropdown-wormhole");